import { ICriteria } from './criteria.interface';
import { ISchedule } from './schedule.interface';

export interface ISetScheduleReportRequest {
  reportId: string;
  fields?: any[];
  pageNumber?: number;
  pageSize?: number;
  criteria?: ICriteria[];
  orderCriteria?: string;
  direction?: string;
  schedule: ISchedule;
  // cronExpression: string;
  id?: string;
  // organization: string;
  // query: string;
  // reportName: string;
  // source: string;
  // useEntityService: number;
}
